module.exports = __webpack_public_path__ + "static/media/galdinsWon_250_500.212d0e1d.png";